import {useParams} from '@aboutyou/router';

export function useSectionIdFromUrl() {
  const {sectionId} = useParams<{sectionId?: string}>();
  if (sectionId == null) {
    return undefined;
  }

  // Extract numeric ID from format like "gutscheine-360003913380"
  const numericPart = sectionId.split('-').pop();
  return numericPart != null ? Number(numericPart) : undefined;
}
